import { createSelector } from 'reselect';
import invariant from 'invariant';

export const PROCEDURE_DROPDOWN_STATE_KEY = 'procedureDropdown';

export const procedureDropdownSelector = createSelector(
    state => {
        invariant(
            state.hasOwnProperty(PROCEDURE_DROPDOWN_STATE_KEY),
            `Expected the procedure dropdown state to be available as \`state.${PROCEDURE_DROPDOWN_STATE_KEY}\`. ` +
            'Ensure you have added the `ProcedureDropdownReducer` to your store\'s reducers via `combineReducers`.'
        );

        return state[PROCEDURE_DROPDOWN_STATE_KEY];
    },
    state => state
);

export default procedureDropdownSelector;
